import { useToast } from '@/components/ui/toast'
import type { RangeColor } from './types'

const { toast } = useToast()

export const addRange = (range: RangeColor[]) => {
  range.push({
    start_range: 0,
    end_range: 100,
    color: '#000000',
  })
}

export const removeRange = (range: RangeColor[], index: number) => {
  if (range.length === 1) {
    toast({
      title: 'Erreur',
      description: 'Vous ne pouvez pas supprimer la dernière range',
      variant: 'destructive',
    })
    return
  }

  range.splice(index, 1)
}

export const getRangeColor = (ranges: RangeColor[], value: string) => {
  const numericValue = parseFloat(value)
  const range = ranges.find(
    (range) => numericValue >= range.start_range && numericValue <= range.end_range,
  )
  return range ? range.color : '#000000'
}
